import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpResponse,
} from '@angular/common/http';
import { Subject, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { PKApolloQueryResult } from "@nx-monorepo/api-base/lib";
import { MediaService } from '@nx-monorepo/obce/ng/services';
import { catchError, map, tap, filter } from 'rxjs/operators';

@Injectable()
export class UploadService {
  //todo in future make generic owner and put it in base libs
  constructor(private http: HttpClient, private authService: AuthService, private mediaService: MediaService) {
  }

  /*  public createFolder(name: string): Observable<HttpEvent<{}>> {
      const formData: FormData = new FormData();
      formData.append('folder_name', name);

      const req = new HttpRequest('POST', '/create-folder', formData);
      return this.http.request(req);
    }*/

  private uploadFileToS3(file, callback: (err, data) => void, onProgress: (progress: number) => void) {
    var formData = new FormData();
    formData.append('file', file);
    this.http.post('/api/upload-s3', formData, { reportProgress: true, observe: 'events' }).pipe(
      tap(progress => {
        if (progress.type == HttpEventType.UploadProgress) {
          var perc = progress.loaded / progress.total * 100;
          onProgress(perc);
        }
      }),
      filter(res => res.type == HttpEventType.Response),
      map(res => [null, (res as HttpResponse<unknown>).body]),
      catchError((err) => of([err, null]))
    ).subscribe(([err, res]) => {
      callback(err, res);
    });

  }

  public upload(payload: { files: Array<File>, fileCategories: Array<number> }): ProgressResult {
    // this will be the our resulting map
    const status: ProgressResult = {};
    const { files, fileCategories } = payload;

    files.forEach((file, index) => {

      // create a new progress-subject for every file
      const uploadState = new Subject<MediaUploadState>();
      let mediumId = null;

      //create upload callback
      const callback = async (err, data) => {
        if (err) {
          console.error('There was an error uploading your file: ', err);
          return false;
        }

        // save the medium to DB
        mediumId = await this.mediaService.save({
          input: {
            kategorie_id: fileCategories[index],
            mime: file.type,
            nazev: file.name,
            url: data.Location
          }
        })
          .toPromise().then((res: PKApolloQueryResult) => res.data.response[0].id);

        // last emit
        uploadState.next({ progress: 100, mediaId: mediumId })

        // complete the observable
        uploadState.complete();
      };

      // upload to S3 bucket
      this.uploadFileToS3(file, callback, (progress) => {
        const percentDone = progress;
        uploadState.next({ progress: percentDone, mediaId: null });
      });

      // Save every progress-observable in a map of all observables
      status[file.name] = {
        state: uploadState.asObservable()
      };
    });

    // return the map of progress.observables
    return status;
  }
}

export interface ProgressResult {
  // filename
  [key: string]: {
    state: Observable<MediaUploadState>; // observer with progress and mediaId
  }
}

export interface MediaUploadState {
  progress: number;
  mediaId?: number;
}
